import { render } from "./FAQList.vue?vue&type=template&id=c23691dc&ts=true"
import script from "./FAQList.vue?vue&type=script&lang=ts"
export * from "./FAQList.vue?vue&type=script&lang=ts"

import "./FAQList.vue?vue&type=style&index=0&id=c23691dc&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__